<div class="flex flex-col gap-4 justify-center items-center w-full h-full">
  <div class="grid grid-cols-2 gap-2 icons-grid">
    <ts-icon class="p-2 border-2 border-black-300" icon="ts_chart-bar" color="light-gray" size="mid-small" />
    <ts-icon class="p-2 border-2 border-black-300" icon="ts_chart-line" color="light-gray" size="mid-small" />
    <ts-icon class="p-2 border-2 border-black-300" icon="ts_chart-pie-alt" color="light-gray" size="mid-small" />
    <ts-icon class="p-1" [icon]="icon" color="orange" size="medium" />
  </div>
  <div class="flex flex-col gap-1 justify-center items-center">
    <p class="text-2xl font-semibold text-center" *ngIf="title">{{ title }}</p>
    <p *ngIf="title && subtitle">{{ subtitle }}</p>
  </div>
  <ng-content select="[empty-state-content]"></ng-content>
  <ts-button
    *ngIf="buttonConfig"
    (click)="buttonConfig.actionFn()"
    [appAuthorize]="authorizeButton"
    denyAction="disable"
    [disabled]="disabled"
    >{{ buttonConfig.label }}</ts-button
  >
</div>
